import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates after `delayMs` of no changes.
 *
 * Used to decouple the responsive search input (which updates on every keystroke) from
 * the expensive filter pipeline + card re-render: the input stays snappy while the
 * pipeline runs at most once per settle. See Projects/ProjectFair search wiring.
 */
export function useDebouncedValue<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
